<template>
  <div class="schedule-detaisl-wrapper">
    <img v-if="schedule.imageUrl" class="poster-image" :src="schedule.imageUrl" />
    <ScheduleRow :schedule="schedule" :show-link-icon="false" />
    <button v-if="schedule.externalLink" class="go-to-arena" @click="goToLink(schedule.externalLink)">
      {{ $t('To read more') }}
    </button>
  </div>
</template>

<script>
import ScheduleRow from '@/components/popup/schedule-row';

import { mapGetters } from 'vuex';

export default {
  components: {
    ScheduleRow,
  },
  computed: {
    ...mapGetters('schedule', ['schedule']),
  },
  methods: {
    goToLink(link) {
      window.open(link, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule-detaisl-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .poster-image {
    width: 100%;
    min-height: 200px;
    border: none;
  }

  .schedule-row {
    width: 100%;
    margin-top: 12px;
  }

  .go-to-arena {
    margin-top: 2rem;
    @include load-more;
  }
}
</style>
